import React, { createContext, useMemo, useState } from "react";
import { OrderContextModel } from "./models/OrderContextModel";

const initialState = {
  busStoreId: '',
  deptId: '',
  serviceItemOrder: [],
  selectedItems: {},
  selectedItemSize: {}
};

export const OrderContext = createContext({} as OrderContextModel);

export const OrderProvider = ({ children }: any) => {
  const [state, setState] = useState(initialState);

  const updateBusStoreId = (value: string) => {
    setState((prev) => ({ ...prev, busStoreId: value }));
  };

  const updateDeptId = (value: string) => {
    setState((prev) => ({ ...prev, deptId: value }));
  };

  const updateServiceItemOrder = (value: any) => {
    setState((prev) => ({ ...prev, serviceItemOrder: value }));
  };

  const updateSelectedItems = (value: any) => {
    setState((prev) => ({ ...prev, selectedItems: value }));
  };

  const updateSelectedItemSize = (value: any) => {
    setState((prev) => ({ ...prev, selectedItemSize: value }));
  };

  const resetStore = () => {
    setState(initialState);
  };

  const contextValue = useMemo(() => ({
    ...state,
    updateBusStoreId,
    updateDeptId,
    updateServiceItemOrder,
    updateSelectedItems,
    updateSelectedItemSize,
    resetStore,
  }), [state]);

  return (
    <OrderContext.Provider value={contextValue}>
      {children}
    </OrderContext.Provider>
  );
};
